import React from 'react';
import { InputFields } from './components/InputFields';
import { ModalWindows } from './components/ModalWindows';
import classNames from 'classnames';
import style from './NfcCardsForm.module.scss';

interface IProps {
	isVisible: boolean;
}

export const NfcCardsForm: React.FC<IProps> = React.memo(({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses}>
			<InputFields />
			<ModalWindows />
		</div>
	);
});
